import { ContentTypeFilterClause, ExplorableItemDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { getGenericDefaultFilters } from './getDefaultFilters';
import { GenericCard } from '../../../app/spaces/CardView/GenericCard';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { AccelerationTasks } from '../../../dataAcceleration/resources/AccelerationTasks';
import { AccelerationTaskContentType } from '../ContentTypes';

export const AccelerationTaskDefinition: ExplorableItemDefinition = {
  itemType: 'accelerationTask',
  pluralName: Messages.accelerationTasks,
  emptyStateMessage: Messages.accelerationTasksEmptyMessage,
  contentFilterKeys: [],
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['accelerationTask']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return AccelerationTasks.all().withExtraParams(AccelerationTaskContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list']
};
